import { openSnackbar } from '../../../snackbar/actions/snackbar-actions';
import issuesService from '../services';
import { PolicyFixInput } from '../types/issues-types';

export const addPolicyFix = async (
  variables: PolicyFixInput[],
  settingType: string,
  sourceControlType: string,
) => {
  const response = await issuesService.addPolicyFix.execute({
    sourceControlType,
    inputs: variables.map(v => ({
      name: v.name,
      type: v.type,
      options: v.options
        .filter(o => o.selected)
        .map(o => ({
          metadata: o.metadata,
          name: o.name,
        })),
    })),
    settingType,
  });
  if (response.success) {
    openSnackbar('The fix was applied successfully!', { variant: 'success' });
  } else {
    openSnackbar(response.error || 'Failed to add the fix', {
      variant: 'error',
    });
  }
};
